var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "article",
    {
      class: [_vm.labelClass, "dc-post-grid-card", "nansen-card"],
      attrs: { id: _vm.id },
      on: {
        click: function($event) {
          $event.stopPropagation()
          $event.preventDefault()
          return _vm.goToPost()
        }
      }
    },
    [
      _c("div", { staticClass: "card-inner" }, [
        _c(
          "div",
          {
            ref: "cardContentWrapper",
            staticClass: "card-inner__content-wrapper"
          },
          [
            _c("div", { staticClass: "card-inner__text-wrapper" }, [
              _c("div", [
                _c(
                  "div",
                  { staticClass: "card-inner__text-wrapper__terms-wrapper" },
                  _vm._l(_vm.terms, function(term, i) {
                    return _c("div", {
                      key: i,
                      domProps: { innerHTML: _vm._s(term) }
                    })
                  }),
                  0
                ),
                _vm._v(" "),
                _vm.title
                  ? _c("h1", { staticClass: "card-title" }, [
                      _vm._v(_vm._s(_vm.title))
                    ])
                  : _vm._e(),
                _vm._v(" "),
                _vm.excerpt
                  ? _c("p", {
                      staticClass: "card-excerpt",
                      domProps: { innerHTML: _vm._s(_vm.excerpt) }
                    })
                  : _vm._e()
              ]),
              _vm._v(" "),
              _vm.url
                ? _c(
                    "a",
                    {
                      ref: "postLink",
                      staticClass: "link read-more-link",
                      attrs: { href: _vm.url }
                    },
                    [_vm._v(_vm._s(_vm.dctxt("lesMerAlt")))]
                  )
                : _vm._e()
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "card-inner__image-wrapper" }, [
              _vm.image
                ? _c("img", {
                    attrs: {
                      src: _vm.image.src,
                      alt: _vm.image.alt,
                      srcset: _vm.image.srcset
                    }
                  })
                : _vm._e()
            ])
          ]
        )
      ])
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }